





































import { studentLimitModule } from "@/plugins/modules-detect";

interface IRequestByStatuses {
  not_processed: Array<ILearningRequest> | undefined;
  waiting_payment: Array<ILearningRequest> | undefined;
  learning: Array<ILearningRequest> | undefined;
  learning_finished: Array<ILearningRequest> | undefined;
  documents_ready: Array<ILearningRequest> | undefined;
  completed: Array<ILearningRequest> | undefined;
  cancelled: Array<ILearningRequest> | undefined;
}

import { Vue, Component, Prop } from "vue-property-decorator";
import OrderItemCard from "@/components/orders/OrderItemCard.vue";
import draggable from "vuedraggable";
import {
  LearningRequest as ILearningRequest,
  LearningRequestStatusEnum
} from "@/api/models/learning-request";
import { availableStatuses, learningStatus } from "@/plugins/learning-status";
import { debounce as _debounce } from "lodash";

@Component({
  components: { OrderItemCard, draggable }
})
export default class OrdersListKanban extends Vue {
  @Prop({ default: [] }) requests?: Array<ILearningRequest>;
  @Prop({ default: true }) isCanDraggable?: boolean;
  @Prop({ default: false }) isShowSpinner?: boolean;
  list!: IRequestByStatuses | undefined;

  data() {
    return {
      list: undefined
    };
  }

  get isStudentLimitModule() {
    return studentLimitModule() && this.$store.state.studentLimit !== 0;
  }

  checkDisabled(item: ILearningRequest) {
    if (
      this.isStudentLimitModule &&
      this.$store.state.studentLimit - this.$store.state.studentAmount <
        item.users.length &&
      (item.status === LearningRequestStatusEnum.NotProcessed ||
        item.status === LearningRequestStatusEnum.WaitingPayment) &&
      item.resourceType !== "course2"
    ) {
      return "disable-draw";
    }
  }

  sortedByStatuses() {
    this.list = {
      not_processed: this.requests?.filter(el => el.status === "not_processed"),
      waiting_payment: this.requests?.filter(
        el => el.status === "waiting_payment"
      ),
      learning: this.requests?.filter(el => el.status === "learning"),
      learning_finished: this.requests?.filter(
        el => el.status === "learning_finished"
      ),
      documents_ready: this.requests?.filter(
        el => el.status === "documents_ready"
      ),
      completed: this.requests?.filter(el => el.status === "completed"),
      cancelled: this.requests?.filter(el => el.status === "cancelled")
    };
  }

  get scrollDebounced() {
    return _debounce(this.checkScroll, 500);
  }

  get allStatuses() {
    return availableStatuses();
  }

  checkDraggableState() {
    return this.isCanDraggable;
  }

  formattedStatuses(item: string) {
    return learningStatus(item);
  }

  checkScroll(event: any) {
    let cltHeight = event.target?.clientHeight;
    let scrHeight = event.target?.scrollHeight;
    let scrTop = event.target?.scrollTop;
    let percentage = ((cltHeight + scrTop) / scrHeight).toFixed(2);

    if (parseFloat(percentage) >= 0.9) {
      this.$emit("scrollEnd");
    }
  }

  changeCard(event: any, list: any) {
    const fromBoard = event?.removed?.element;
    const toBoard = event?.added?.element;

    const data = {
      targetList: list,
      targetElement: fromBoard ? fromBoard : toBoard
    };

    if (toBoard) {
      this.$emit("changeRequestStatus", data.targetList, data.targetElement);
    }
  }

  created() {
    this.sortedByStatuses();
  }
}
